module.exports = "/images/Schlagg_d02e54.jpg";